import { differenceInDays, differenceInMinutes, parseISO } from "date-fns";
import { format } from "date-fns-tz";
import { ISO8601 } from "Doctor/Model";
import { Visit } from "./Model";

export type VisitsGroupedByDate = {
  [key in ISO8601]: Visit[];
};

export function groupVisitsWithSameDate(
  visitsList: Visit[]
): VisitsGroupedByDate {
  return visitsList.reduce((visitsGroupedByDate, visit) => {
    const ISODateKey = format(new Date(visit.timeSlot.from), "yyyy-MM-dd");
    return {
      ...visitsGroupedByDate,
      [ISODateKey]: [...(visitsGroupedByDate[ISODateKey] || []), visit],
    };
  }, {} as VisitsGroupedByDate);
}

export function sortVisitGroupsByDate(
  visitsGroupA: [ISO8601, Visit[]],
  visitsGroupB: [ISO8601, Visit[]],
  order: "asc" | "desc"
) {
  const diff = differenceInDays(
    parseISO(visitsGroupA[0]),
    parseISO(visitsGroupB[0])
  );
  return order === "asc" ? diff : -diff;
}

export function sortVisitsByTime(visitA: Visit, visitB: Visit, order: "asc" | "desc") {
  const diff = differenceInMinutes(
    parseISO(visitA.timeSlot.from),
    parseISO(visitB.timeSlot.from)
  );
  return order === "asc" ? diff : -diff;
}
